export const getBrandBasePath = (pathname = window?.location?.pathname || "") => {
  const lowerPath = pathname.toLowerCase();

  return lowerPath.includes("/creighton") ? "/creighton" : "/entrepreneur";
};

export const getBrandIntroductionPath = (pathname = window?.location?.pathname || "") => {
  return `${getBrandBasePath(pathname)}/introduction`;
};

export const getBrandPath = (pathname = window?.location?.pathname || "", subPath = "") => {
  const basePath = getBrandBasePath(pathname);
  const normalizedSubPath = subPath ? `/${String(subPath).replace(/^\/+/, "")}` : "";

  return `${basePath}${normalizedSubPath}`;
};
